export default "__VITE_ASSET__C7V5W9LF__"